(() => {
  'use strict';

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const shouldReduceMotion = () => reduceMotion.matches || document.body.classList.contains('reduce-motion');
  const cards = [...document.querySelectorAll('[data-collection-video-card]')];
  if (!cards.length) return;

  const setState = (card, playing) => {
    const button = card.querySelector('[data-video-toggle]');
    if (!button) return;
    button.setAttribute('aria-pressed', String(playing));
    const playLabel = button.querySelector('[data-video-play-label]');
    const pauseLabel = button.querySelector('[data-video-pause-label]');
    if (playLabel) playLabel.hidden = playing;
    if (pauseLabel) pauseLabel.hidden = !playing;
  };

  const playVideo = async (card, explicit = false) => {
    const video = card.querySelector('[data-collection-video]');
    if (!video || (shouldReduceMotion() && !explicit)) return;
    try {
      await video.play();
      setState(card, true);
      if (!card.dataset.analyticsPlayed) {
        card.dataset.analyticsPlayed = 'true';
        window.Orvasco?.publishEvent?.('orvasco:collection_video_played', { collection_handle: window.Orvasco?.collectionHandle || '' });
      }
    } catch { setState(card, false); }
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const video = entry.target.querySelector('[data-collection-video]');
      if (!video) return;
      if (entry.isIntersecting && entry.intersectionRatio >= 0.6) playVideo(entry.target);
      else { video.pause(); setState(entry.target, false); }
    });
  }, { threshold: [0, 0.6, 1] });

  cards.forEach((card) => {
    observer.observe(card);
    const video = card.querySelector('[data-collection-video]');
    const button = card.querySelector('[data-video-toggle]');
    button?.addEventListener('click', () => {
      if (!video) return;
      if (video.paused) playVideo(card, true);
      else { video.pause(); setState(card, false); }
    });
  });
})();

/* Filtre kullanimi: hangi filtrenin denendigi, koleksiyondan cikis sebebini
   anlamak icin gerekli. Shopify"nin kendi pikseli bunu gormez. */
(() => {
  'use strict';
  document.addEventListener('change', (event) => {
    const input = event.target.closest('.collection-filter__values input, .collection-filter__price input');
    if (!input) return;
    window.Orvasco?.publishEvent?.('orvasco:filter_used', {
      filter: input.name || '',
      value: input.value || '',
      collection: window.Orvasco?.collectionHandle || ''
    });
  });
  document.addEventListener('change', (event) => {
    const sort = event.target.closest('select[name="sort_by"]');
    if (!sort) return;
    window.Orvasco?.publishEvent?.('orvasco:sort_used', { sort_by: sort.value });
  });
})();
